import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

export const Modal = ({ open, onClose, children, testid }) => (
  <AnimatePresence>
    {open && (
      <motion.div
        className="fixed inset-0 z-[100] flex items-end md:items-center justify-center"
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
        data-testid={testid}
      >
        <div className="absolute inset-0 bg-sage-deep/50 backdrop-blur-sm" onClick={onClose} />
        <motion.div
          initial={{ y: 40, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 40, opacity: 0 }}
          transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
          className="relative w-full md:max-w-2xl max-h-[92vh] overflow-y-auto bg-white rounded-t-[2rem] md:rounded-[2rem] shadow-2xl"
          data-lenis-prevent
        >
          <button onClick={onClose} className="absolute top-4 right-4 z-10 w-10 h-10 rounded-full bg-cream border border-line flex items-center justify-center text-ink-soft hover:bg-cream-deep transition-colors" data-testid="modal-close" aria-label="Cerrar">
            <X size={20} />
          </button>
          {children}
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);

export const field = "w-full rounded-xl border border-line bg-cream/50 px-4 py-3 text-ink placeholder-ink-faint outline-none focus:border-forest focus:ring-2 focus:ring-forest/20 transition-all duration-200";
export const label = "block text-sm font-medium text-ink-soft mb-1.5";
